<template>
  <div class="com" v-if="!isActivated">
    <div class="txt">
      How would you like to receive your status and reports? Choose at least
      one. Verification required.
    </div>
    <div class="checkbox-section-wrapper">
      <div class="label-checkbox">
        <span class="checkbox-txt">{{ contacts.mail }}</span>
        <div class="checkbox-wrap">
          <input type="checkbox" class="checkbox" v-model="emailInput" />
          <span class="slider"></span>
        </div>
      </div>
      <codeNumber
        ref="emailCode"
        v-show="verifyCodeSendedEmail === true && emailInput"
        field="email"
        :item="contacts.mail"
        :email="contacts.mail"
        @nextStep="nextStep"
        @verified="verified"
      ></codeNumber>
      <div class="label-checkbox">
        <span class="checkbox-txt">{{ makePhone(contacts.phone) }}</span>
        <div class="checkbox-wrap">
          <input
            type="checkbox"
            class="checkbox"
            name="twilio"
            v-model="phoneInput"
          />
          <span class="slider"></span>
        </div>
        <span class="validate-error twilio" v-if="errors.has('twilio')">{{
          setError(errors.first("twilio"))
        }}</span>
      </div>
      <codeNumber
        ref="phoneCode"
        v-show="verifyCodeSendedPhone === true && phoneInput"
        field="phone"
        @nextStep="nextStep"
        @verified="verified"
        :item="makePhone(contacts.phone)"
      ></codeNumber>
    </div>
    <button class="btn" @click="switchStep" :disabled="isComputed">
      Verify
    </button>
    <button class="back-btn" @click="prev">Go back</button>
  </div>
  <Activated v-else @nextStep="samplingStep"></Activated>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import CodeNumber from "../CodeNumber";
import Activated from "./Activated";

export default {
  name: "Notification",
  props: ["notificationData"],
  data() {
    return {
      emailInput: false,
      phoneInput: false,
      errorCode: true,
      emailInputVer: false,
      phoneInputVer: false,
      isActivated: false
    };
  },
  components: {
    CodeNumber,
    Activated
  },
  computed: {
    ...mapGetters([
      "verifyCodeSendedEmail",
      "verifyCodeSendedPhone",
      "contacts",
      "userInfo",
      "serverValidation"
    ]),
    isComputed() {
      return !(this.phoneInput === true || this.emailInput === true);
    }
  },
  watch: {
    notificationData() {
      if (this.notificationData !== null) {
        this.emailInput = this.notificationData.emailInput;
        this.phoneInput = this.notificationData.phoneInput;
        this.errorCode = this.notificationData.errorCode;
        this.emailInputVer = this.notificationData.emailInputVer;
        this.phoneInputVer = this.notificationData.phoneInputVer;
      }
    },
    serverValidation(error) {
      error.forEach(item => {
        this.$validator.errors.add({ field: item.field, msg: item.message });
      });
    }
  },
  methods: {
    setError(str) {
      const errorArray = str.split(" ");
      errorArray.forEach(
        (item, index) =>
          item.includes("+1") &&
          (errorArray[index] = this.makePhone(item, true))
      );
      return errorArray.join(" ");
    },
    makePhone(phone, withPlus) {
      if (phone) {
        // Check if phone is null or undefined
        if (phone === null || phone === undefined) {
          return null;
        }

        // Remove any non-digit characters from the input
        const cleanPhone = phone.replace(/\D/g, '');

        // Check if the cleaned phone number is exactly 10 digits
        if (cleanPhone.length === 11 || cleanPhone.length === 10) {
          const phoneArr = cleanPhone.split("");
          let  convertedPhone = null;
          if (cleanPhone.length === 11){
          convertedPhone = `(${phoneArr[1]}${phoneArr[2]}${phoneArr[3]}) ${phoneArr[4]}${phoneArr[5]}${phoneArr[6]}-${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}${phoneArr[10]}`;
          } else if (cleanPhone.length === 10) {
          convertedPhone = `(${phoneArr[0]}${phoneArr[1]}${phoneArr[2]}) ${phoneArr[3]}${phoneArr[4]}${phoneArr[5]}-${phoneArr[6]}${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}`;
          }
          return convertedPhone;
        } else {
          return null;
        }
      }
    },
    ...mapActions(["sendUserInfoNot","associateKitId"]),
    ...mapMutations([
      "back",
      "clearServerValidationErrors",
      "verifyEmail",
      "verifyPhone"
    ]),
    switchStep() {
      if (this.emailInput && this.verifyCodeSendedEmail) {
        this.$refs.emailCode.sendData();
      }

      if (this.phoneInput && this.verifyCodeSendedPhone) {
        this.$refs.phoneCode.sendData();
      }

      const user = {
        notifications_sms: this.phoneInput && !this.verifyCodeSendedPhone,
        notifications_email: this.emailInput && !this.verifyCodeSendedEmail,
        from: true
      };
      this.sendUserInfoNot(user).then(res => {
        this.errors.clear();
        this.clearServerValidationErrors();
      });
    },
    prev() {
      this.errors.clear();
      this.back(true);
      this.verifyEmail(false);
      this.verifyPhone(false);
      this.emailInput = false;
      this.phoneInput = false;
      this.errorCode = true;
      this.emailInputVer = false;
      this.phoneInputVer = false;
      this.$emit("prevStep", 1);
    },
    nextStep(e) {
      if (e.field === "phone") {
        this.phoneInputVer = true;
        this.swtchStep();
      } else {
        this.emailInputVer = true;
        this.swtchStep();
      }
    },
    verified(e){

    },
    swtchStep() {
      if (
        (this.phoneInput === true &&
          this.emailInput === true &&
          this.emailInputVer === true &&
          this.phoneInputVer === true) ||
        (this.phoneInput === true &&
          this.emailInput === false &&
          this.emailInputVer === false &&
          this.phoneInputVer === true) ||
        (this.phoneInput === false &&
          this.emailInput === true &&
          this.emailInputVer === true &&
          this.phoneInputVer === false)
      ) {
        this.associateKitId({
          kit_id: this.userInfo.kit_id
        }).then(res => {
          this.isActivated = true;
        });
      }
    },
    samplingStep() {
      this.$emit("nextStep", 1);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.checkbox-section-wrapper {
  margin: 20px 0 10px 0;
}
.label-checkbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 0 30px;
  &:first-child {
    margin-bottom: 16px;
  }
}
.checkbox {
  opacity: 0;
  width: 100%;
  margin: 0;
  height: 100%;
  z-index: 1;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
}
.checkbox-wrap {
  position: relative;
  width: 56px;
  height: 24px;
}

.checkbox-toggle-text {
  position: absolute;
  z-index: 2;
  color: $white;
  font-size: 11px;
  text-transform: uppercase;
  font-family: TTNormsMedium, sans-serif;
  top: 12px;
  left: 15px;
}
.checkbox-toggle-text-right {
  left: auto;
  right: 15px;
}
.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  width: 100%;
  height: 100%;
  border-radius: 20px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 28px;
  width: 28px;
  left: 0;
  bottom: -2px;
  box-shadow: 0 0 2px 1px $boxShadow;
  background-color: $white;
  transition: 0.4s;
  border-radius: 100%;
}
.checkbox:checked + .slider {
  background-color: $green;
}

.checkbox:checked + .slider:before {
  transform: translateX(28px);
}
.txt {
  color: $gray;
  font-size: 16px;
  text-align: center;
  margin: 20px 0 0 0;
  font-family: TTNormsRegular, sans-serif;
  line-height: 1.3;
}

.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsBold, sans-serif;
}
.back-btn {
  color: $green;
  border: none;
  cursor: pointer;
  outline: none;
  display: block;
  background-color: transparent;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  margin: 36px auto 0 auto;
}
.checkbox-txt {
  font-size: 16px;
  width: 75%;
  overflow: hidden;
  font-family: TTNormsMedium, sans-serif;
  color: $gray;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
@media screen and (max-width: 768px) {
  .label-checkbox {
    padding: 0 20px;
  }
}
</style>
